import curry from './curry';
/**
 * Getter of properties.
 */

var prop = curry(function (property, o) {
  return o[property];
});
export default prop;